import * as React from 'react'

import type { MatchSport } from '../../../../../../App.types'
import type { Action } from '../../helpers/matches-filters-reducer'

import DesktopSportsFilter from './DesktopSportsFilter'
import MobileSportsFilter from './MobileSportsFilter'

interface Props {
  sports?: Array<MatchSport>
  dispatch: React.Dispatch<Action>
  isMobile?: boolean
  selectedSports?: Array<string>
}

const SportsFilter = ({ sports, dispatch, selectedSports, isMobile }: Props) => {
  if (!sports) return null
  return isMobile ? (
    <MobileSportsFilter dispatch={dispatch} sports={sports} selectedSports={selectedSports} />
  ) : (
    <DesktopSportsFilter dispatch={dispatch} sports={sports} selectedSports={selectedSports} />
  )
}

export default SportsFilter
